import { useState } from "react";

import "./business-card.scss";

import sms from "../../assets/icons/sms.svg";
import linkdin from "../../assets/icons/linkdin1.svg";
import site from "../../assets/icons/site.svg";
import QR from "../../assets/imgs/QR_code_for_mobile_English_Wikipedia 1.png";
import { CallCalling } from "iconsax-react";

function BlogCard() {
    const [flipped, setFlipped] = useState(true);
    const flip = () => {
        setFlipped(!flipped);
    };

    const validateURL = url => {
        const parsed = new URL(url);
        return ["https:", "http:"].includes(parsed.protocol);
    };

    return (
        <div className="main">
            <div className="card-wrapper">
                <div className={`business-card ${flipped ? "" : "flipped"}`} onClick={flip}>
                    {flipped ? (
                        <div className="card-front">{/* <div className='layer'></div> */}</div>
                    ) : (
                        <div className="card-back">
                            <div className="left-back">
                                {/* <div className="profile"><img src={alishahi}></img></div> */}
                                <div>
                                    <div>
                                        <span className="first-name">Mohammad </span>
                                    </div>
                                    <div>
                                        <span className="last-name"> Alishahi</span>
                                    </div>
                                </div>
                                <div className="left-back__driver"></div>
                                <div className="left-back__footer">
                                    <span> CEO & Founder</span>
                                    <span>PHD in Software Engineering</span>
                                </div>
                            </div>
                            <div className="right-back">
                                <div className="information">
                                    <div>
                                        {/* <img src={phone}></img> */}
                                        <CallCalling color="var(--light-color)" />
                                    </div>
                                    <div className="content">
                                        <span className="data">+98-9153171983</span>
                                        <span className="data">+98-5136572582</span>
                                    </div>
                                </div>
                                <div className="information">
                                    <div>
                                        <img src={sms}></img>
                                    </div>
                                    <div className="content">
                                        <span className="data">alishahi@atripa.com</span>
                                        <span className="data">alishahi@ieee.org</span>
                                    </div>
                                </div>
                                <div className="information">
                                    <div>
                                        <img src={linkdin}></img>
                                    </div>
                                    <div className="content">
                                        <span className="data">linkedin.com/in/moh-alishahi</span>
                                    </div>
                                </div>
                                <div className="information">
                                    <div>
                                        <img src={site}></img>
                                    </div>
                                    <div className="content">
                                        <span className="data">
                                            <a href={validateURL("https://atripa.ir/") ? "https://atripa.ir/" : ""}>www.atripa.com</a>
                                        </span>
                                    </div>
                                </div>

                                {/* <div className="QR">
                                    <div>
                                        <img src={QR}></img>
                                    </div>
                                    <div>
                                        <span className="data">Scan to visit us online</span>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default BlogCard;
